module.exports = __webpack_public_path__ + "static/media/Lahore High Court.b8083193.jpg";